import _isNull from 'lodash/isNull';

/**
 * Determines if there is no data for the given metric
 *
 * @param {number} metricValue metric value
 */
export const isMetricValueEmpty = (metricValue) => _isNull(metricValue) || metricValue === 0;
